import { createRoute } from '@tanstack/react-router';
import { KontaktyList } from '@/modules/kontakty/KontaktyList';
import { parseKontaktySearch } from '@/modules/kontakty/filters';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/kontakty',
  component: KontaktyList,
  validateSearch: parseKontaktySearch,
});
